/**
 * Shown when a workflow item exists but this user may not open it.
 *
 * Deliberately not a 404 and not an error: the page is real, the URL is probably one a
 * colleague shared, and the honest answer is that access is restricted rather than that
 * something went wrong.
 */
export function WorkflowItemNotAvailable() {
  return (
    <div className="budget-empty">
      <div className="budget-empty__title">Not available to your account</div>
      <div className="budget-empty__body">
        This page is restricted while it is being tested. Ask an administrator if you need
        access to it.
      </div>
    </div>
  )
}
